import React, { useEffect } from 'react';
import { Button, Flex } from 'antd';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { PushpinFilled, PushpinOutlined } from '@ant-design/icons';
import {
  PieChartOutlined,
  ContainerOutlined,
  PlusOutlined,
  BankOutlined,
  DollarOutlined,
  FileTextOutlined,
  WalletOutlined,
  TransactionOutlined,
  ReconciliationOutlined,
  ContactsOutlined,
  SettingOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  AuditOutlined,
  GoldOutlined,
  ControlOutlined,
  SnippetsOutlined
} from '@ant-design/icons';
import { SidebarContextMenu } from './SidebarContextMenu';
import { addPinnedToModule, removePinnedToModule } from '@/redux/actions';

const MenuItemWithIcons = ({ label, addPath, listPath, setOpenDropdown, isPinned, moduleId, dispatch, messageApi, isRoot }) => {
  const navigate = useNavigate();

  return (
    <SidebarContextMenu path={listPath}>
      <div className={'menu-label-button-wrapper'}>
        <span className='menu-label'>{label}</span>
        <Flex gap={'small'}>
          {isRoot ? null : (isPinned ? (
            <PushpinFilled
              style={{ color: '#1677ff' }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                dispatch(removePinnedToModule(moduleId)).then((res) => {
                  console.log('<<response--', res);
                  messageApi.success(`Removed pinned from ${label}.`);
                }).catch((e) => {
                  console.log('<<e--', e);
                  messageApi.error(`Failed to remove pinned from ${label}.`);
                })
              }}
            />
            ) : (
            <PushpinOutlined
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                dispatch(addPinnedToModule(moduleId)).then((res) => {
                  messageApi.success(`Added pinned to ${label}.`);
                }).catch((e) => {
                  messageApi.error(`Failed to add pinned to ${label}.`);
                })
              }}
            />
          ))}
          <Button
            size={'small'}
            type={'primary'}
            icon={<PlusOutlined/>}
            onClick={(e) => {
              e.stopPropagation();
              navigate(addPath);
              setOpenDropdown?.(null);
            }}
          />
        </Flex>
      </div>
    </SidebarContextMenu>
  );
};
const SidebarContext = ({ label, path, isPinned, moduleId, dispatch, messageApi, isRoot }) => {
  return (
      <SidebarContextMenu path={path}>
      <div className={'menu-label-button-wrapper'}>
        <span className='menu-label'>{label}</span>
        {isRoot ? null : (isPinned ? (
            <PushpinFilled
              style={{ color: '#1677ff' }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                dispatch(removePinnedToModule(moduleId)).then((res) => {
                  console.log('<<response--', res);
                  messageApi.success(`Removed pinned from ${label}.`);
                }).catch((e) => {
                  console.log('<<e--', e);
                  messageApi.error(`Failed to remove pinned from ${label}.`);
                })
              }}
            />
            ) : (
            <PushpinOutlined
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                dispatch(addPinnedToModule(moduleId)).then((res) => {
                  messageApi.success(`Added pinned to ${label}.`);
                }).catch((e) => {
                  messageApi.error(`Failed to add pinned to ${label}.`);
                })
              }}
            />
          ))}
      </div>
      </SidebarContextMenu>
    )
}
const SidebarMenuWithIcons = ({ label, path, setOpenDropdown, isPinned, moduleId, dispatch, messageApi, isRoot }) => {
  return (
    <MenuItemWithIcons
      label={label}
      addPath={`${path}/alter`}
      listPath={path}
      setOpenDropdown={setOpenDropdown}
      isPinned={isPinned}
      moduleId={moduleId}
      dispatch={dispatch}
      messageApi={messageApi}
      isRoot={isRoot}
    />
  )
}
export const menuDetails = [
    {
      key: 'dashboard',
      label: SidebarContext,
      icon: React.createElement(PieChartOutlined)
    },
    {
      key: 'general-settings',
      label: SidebarContext,
      icon: React.createElement(SettingOutlined)
    },
    {
      key: 'user-settings',
      label: 'User Settings',
      icon: React.createElement(ContainerOutlined),
    },
    {
      key: 'user',
      label: SidebarContext,
    },
    {
      key: 'user-rights',
      label: SidebarContext
    },
    {
      key: 'masters',
      label: 'Masters',
      icon: React.createElement(ContactsOutlined),
    },
    {
      key: 'company',
      label: SidebarContext
    },
    {
      key: 'broker',
      label: SidebarContext
    },
    {
      key: 'area',
      label: SidebarContext
    },
    {
      key: 'banks',
      label: SidebarContext
    },
    {
      key: 'sales-person',
      label: SidebarContext
    },
    { 
      key: 'schedule',
      label: SidebarContext
    },
    { 
      key: 'transporter',
      label: SidebarContext
    },
    {
      key: 'hsncode',
      label: SidebarContext
    },
    {
      key: 'item',
      label: SidebarContext
    },
    {
      key: 'account',
      label: SidebarContext
    },
    {
      key: 'design',
      label: SidebarContext
    },
    {
      key: 'lot',
      label: SidebarContext
    },
    {
      key: 'book',
      label: SidebarContext
    },
    {
      key: 'report-master',
      label: SidebarContext
    },
    {
      key: 'worker-master',
      label: SidebarContext
    },
    {
      key: 'worker-attendance-monthly',
      label: SidebarContext
    },
    {
      key: 'worker-upad',
      label: SidebarContext
    },
    {
      key: 'worker-jama',
      label: SidebarContext
    },
    {
      key: 'grade',
      label: SidebarContext
    },
    {
      key: 'tds-section',
      label: SidebarContext
    },
    {
      key: 'machine',
      label: SidebarContext
    },
    {
      key: 'branch',
      label: SidebarContext
    },
    {
      key: 'bobin-type',
      label: SidebarContext
    },
    {
      key: 'item-lot-rate',
      label: SidebarContext
    },
    {
      key: 'inventory',
      label: 'Inventory',
      icon: React.createElement(ReconciliationOutlined),
    },
    {
      key: 'beam',
      label: SidebarMenuWithIcons
    },
    {
      key: 'production-entry',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'production-repacking-entry',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'production-purchase-entry',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'delivery-challan-entry',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'delivery-challan-return-entry',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'transaction',
      label: 'Transaction',
      icon: React.createElement(TransactionOutlined),
    },
    {
      key: 'sales-order',
      label: SidebarMenuWithIcons
    },
    {
      key: 'sales-bill',
      label: SidebarMenuWithIcons
    },
    {
      key: 'sales-return',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'purchase-order',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'purchase-challan',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'purchase-challan-return',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'purchase-bill',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'purchase-bill-return',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'general-purchase-bill',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'general-purchase-return-bill',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'journal-voucher',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'journal-voucher-multy',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'debit-note',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'credit-note',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'debit-note-bill-base',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'credit-note-bill-base',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'debit-note-bill-base-return',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'credit-note-bill-base-return',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'bank-cash',
      // label: 'Bank/Cash',
      label: 'Bank/Cash',
      icon: React.createElement(BankOutlined)
    },
    {
      key: 'bank',
      label: 'Bank',
      // icon: React.createElement(BankOutlined),
    },
    {
      key: 'bank-receipt',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'bank-payment',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'bank-receipt-return',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'bank-payment-return',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'bank-slip-entry',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'bank-payment-slip-entry',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'import-bank-statement',
      label: SidebarContext,
    },
    {
      key: 'cash',
      label: 'Cash',
      // icon: React.createElement(WalletOutlined),
    },
    {
      key: 'cash-receipt',
      label: SidebarMenuWithIcons,
      // icon: React.createElement(ContainerOutlined),
    },
    {
      key: 'cash-payment',
      label: SidebarMenuWithIcons,
      // icon: React.createElement(ContainerOutlined),              
    },
    {
      key: 'report',
      label: 'Report',
      icon: React.createElement(FileTextOutlined),
    },
    {
      key: 'daybook-registers',
      icon: React.createElement(ContainerOutlined),
      label: SidebarContext,
    },
    {
      key: 'sales-register',
      label: SidebarContext,
    },
    {
      key: 'sales-return-register',
      label: SidebarContext,
    },
    {
      key: 'sales-order-register',
      label: SidebarContext,
    },
    {
      key: 'purchase-register',
      label: SidebarContext,
    },
    {
      key: 'purchase-return-register',
      label: SidebarContext,
    },
    {
      key: 'purchase-order-register',
      label: SidebarContext,
    },
    {
      key: 'general-purchase-register',
      label: SidebarContext,
    },
    {
      key: 'general-purchase-return-register',
      label: SidebarContext,
    },
    {
      key: 'journal-voucher-register',
      label: SidebarContext,
    },
    {
      key: 'debit-credit-not-register',
      label: SidebarContext,
    },
    {
      key: 'debit-credit-note-bill-base-register',
      label: SidebarContext,
    },
    {
      key: 'bank-cash-register',
      label: SidebarContext,
    },
    {
      key: 'outstanding-reports',
      icon: React.createElement(FileDoneOutlined),
      label: SidebarContext
    },
    {
      key: 'sales-outstanding-register',
      label: SidebarContext,
    },
    {
      key: 'purchase-outstanding-register',
      label: SidebarContext,
    },
    {
      key: 'general-purchase-outstanding-register',
      label: SidebarContext,
    },
    {
      key: 'sales-intrest-calculation-register',
      label: SidebarContext,
    },
    {
      key: 'purchase-intrest-calculation-register',
      label: SidebarContext,
    },
    {
      key: 'sales-paid-bill-detail-register',
      label: SidebarContext,
    },
    {
      key: 'purchase-paid-bill-detail-register',
      label: SidebarContext,
    },
    {
      key: 'unadjust-bill-reports',
      icon: React.createElement(FileSearchOutlined),
      label: SidebarContext
    },
    {
      key: 'sales-return-unadjust-bill-register',
      label: SidebarContext,
    },
    {
      key: 'purchase-return-unadjust-bill-register',
      label: SidebarContext,
    },
    {
      key: 'general-purchase-return-unadjust-bill-register',
      label: SidebarContext,
    },
    {
      key: 'bank-receipt-unadjust-bill-register',
      label: SidebarContext,
    },
    {
      key: 'bank-payment-unadjust-bill-register',
      label: SidebarContext,
    },
    {
      key: 'cash-receipt-unadjust-bill-register',
      label: SidebarContext,
    },
    {
      key: 'cash-payment-unadjust-bill-register',
      label: SidebarContext,
    },
    {
      key: 'debit-note-unadjust-bill-register',
      label: SidebarContext,
    },
    {
      key: 'credit-note-unadjust-bill-register',
      label: SidebarContext,
    },
    {
      key: 'gst-reports',
      icon: React.createElement(AuditOutlined),
      label: SidebarContext,
    },
    {
      key: 'gstr1-report',
      label: SidebarContext,
    },
    {
      key: 'gstr2-report',
      label: SidebarContext,
    },
    {
      key: 'gstr2a-report',
      label: SidebarContext,
    },
    {
      key: 'gstr2b-report',
      label: SidebarContext,
    },
    {
      key: 'gstr3b-report',
      label: SidebarContext,
    },
    {
      key: 'gst-detail-report',
      label: SidebarContext,
    },
    {
      key: 'gst-register-report',
      label: SidebarContext,
    },
    {
      key: 'gstr9-report',
      label: SidebarContext,
    },
    {
      key: 'tds-report',
      label: SidebarContext,
    },
    {
      key: 'tcs-report',
      label: SidebarContext,
    },
    {
      key: 'financial-reports',
      icon: React.createElement(DollarOutlined),
      label: SidebarContext
    },
    {
      key: 'ledger-report',
      label: SidebarContext,
    },
    {
      key: 'bank-reconciliation-ledger-report',
      label: SidebarContext,
    },
    {
      key: 'trial-balance-schedule-report',
      label: SidebarContext,
    },
    {
      key: 'trading-account-report',
      label: SidebarContext,
    },
    {
      key: 'profit-loss-account-report',
      label: SidebarContext,
    },
    {
      key: 'balance-sheet-report',
      label: SidebarContext,
    },
    {
      key: 'stock-detail-report',
      icon: React.createElement(GoldOutlined),
      label: SidebarContext
    },
    {
      key: 'non-issue-ready-goods-yarn-stock',
      label: SidebarContext,
    },
    {
      key: 'non-issue-ready-goods-gray-stock',
      label: SidebarContext,
    },
    {
      key: 'delivery-challan-register-yarn',
      label: SidebarContext,
    },
    {
      key: 'delivery-challan-register-return-yarn',
      label: SidebarContext,
    },
    {
      key: 'production-register-gray',   
      label: SidebarContext,
    },
    {
      key: 'delivery-challan-register-gray',
      label: SidebarContext,
    },
    {
      key: 'delivery-challan-register-return-gray',
      label: SidebarContext,
    },
    {
      key: 'beam-register',
      label: SidebarContext,
    },
    {
      key: 'sub-job-pending-stock-receive-gray',
      label: SidebarContext,
    },
    {
      key: 'sub-job-pending-stock-receive-yarn',
      label: SidebarContext,
    },
    {
      key: 'non-issue-raw-material-stock',
      label: SidebarContext,
    },
    {
      key: 'stock-report',
      icon: React.createElement(GoldOutlined),
      label: SidebarContext
    },
    {
      key: 'sales-order-balance-report-bill-base',
      label: SidebarContext,
    },
    {
      key: 'sales-order-balance-report-challan-base',
      label: SidebarContext,
    },
    {
      key: 'order-delivery-schedule-balance-detail-report',
      label: SidebarContext,
    },
    {
      key: 'purchase-order-balance-report-bill-base',
      label: SidebarContext,
    },
    {
      key: 'purchase-order-balance-report-challan-base',
      label: SidebarContext,
    },
    {
      key: 'utility',
      icon: React.createElement(ControlOutlined)
    },
    {
      key: 'lock-data',
      label: SidebarContext,
    },
    {
      key: 'import-data',
      label: SidebarContext,
    },
    {
      key: 'db-backup',
      label: SidebarContext,
    },
    {
      key: 'inventory-report',
      icon: React.createElement(GoldOutlined),
      label: SidebarContext,
    },
    {
      key: 'production-register-yarn',
      label: SidebarContext,
    },
    {
      key: 'generate-tax-jv',
      label: SidebarContext,
    },
    {
      key: 'job',
      label: SidebarContext,
    },
    {
      key: 'vehicle',
      label: SidebarContext,
    },
    {
      key: 'taka-base',
      icon: React.createElement(GoldOutlined),
    },
    {
      key: 'gray-job-issue',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'gray-job-receive',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'gray-job-return',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'sub-job-issue-entry',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'sub-job-receive',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'sub-job-return',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'machine-wise-beam-stock',
      label: SidebarContext,
    },
    {
      key: 'short-excess',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'short-excess-register',
      label: SidebarContext,
    },
    {
      key: 'item-ledger-report',
      label: SidebarContext,
    },
    {
      key: 'production-detail-gray-report',
      label: SidebarContext,
    },
    {
      key: 'production-detail-yarn-report',
      label: SidebarContext,
    },
    {
      key: 'gst-refund-report',
      label: SidebarContext,
    },
    {
      key: 'cancel-eway-bill-report',
      label: SidebarContext,
    },
    {
      key: 'karigar-salary-report',
      label: SidebarContext,
    },
    {
      key: 'raw-material-inward-challan',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'raw-material-issue-challan',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'raw-material-return-challan',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'mail-template',
      label: SidebarContext,
    },
    {
      key: 'purchase-bill-sales-balance-report',
      label: SidebarContext,
    },
    {
      key: 'date-wise-production-stock-report',
      label: SidebarContext,
    },
    {
      key: 'purchase-sales-order-balance-report',
      label: SidebarContext,
    },
    {
      key: 'import-from-customer',
      label: SidebarContext,
    },
    {
      key: 'scan-whatsapp-device',
      label: SidebarContext,
    },
    {
      key: 'worker-attendance-daily',
      label: SidebarContext
    },
    {
      key: 'vehicle-upad',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'vehicle-salary',
      label: SidebarContext
    },
    {
      key: 'reminder',
      label: SidebarContext
    },
    {
      key: 'year-end-process',
      label: SidebarContext
    },
    {
      key: 'draft',
      // label: 'Bank/Cash',
      label: 'Draft',
      icon: React.createElement(SnippetsOutlined)
    },
    {
      key: 'draft-debit-note-bill-base',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'draft-credit-note-bill-base',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'reverse-gst-charge-report',
      label: SidebarContext,
    },
    {
      key: 'date-wise-production',
      label: SidebarMenuWithIcons
    },
    {
      key: 'date-wise-production-difference',
      label: SidebarMenuWithIcons
    },
    {
      key: 'job-yarn-issue',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'job-yarn-receive',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'job-yarn-return',
      label: SidebarMenuWithIcons,
    },
    {
      key: 'job-yarn-stock-report',
      label: SidebarContext,
    },
    {
      key: 'job-yarn-in-out-report',
      label: SidebarContext,
    },
    {
      key: 'account-item-rate',
      label: SidebarContext,
    },
  ];